
import { Options, Vue } from "vue-class-component";
import BoxWithBtn from "./BoxWithBtn.vue";

@Options({
  components: {
    BoxWithBtn,
  },
  props: {
    item: Map,
  },
  methods: {
    onDetail(link: string) {
      // window.open(link);
      window.location.href = link;
    },
  },
})
export default class BoxWithLatestNews extends Vue {}
